import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const exchangeOrderShippingPriceSource = createEnum([
  "free",
  "customer",
  "site",
] as const);
export type ExchangeOrderShippingPriceSource = z.infer<
  typeof exchangeOrderShippingPriceSource
>;

export const commerceCloudApiKind = createEnum(["admin", "shopper"] as const);
export type CommerceCloudApiKind = z.infer<typeof commerceCloudApiKind>;

/** Credentials are never returned whole — only the last 4 characters. */
const maskedCredentialsSchema = z.object({
  clientIdLast4: z.string(),
  clientSecretLast4: z.string(),
  scopes: z.array(z.string()),
});

export const getCommerceCloudSetup = {
  name: "getCommerceCloudSetup" as const,
  input: z.object({ integrationId: commerceCloudIntegrationId }),
  output: z.object({
    organizationId: z.string(),
    shortCode: z.string(),
    siteId: z.string(),
    instanceId: z.string(),
    realmId: z.string(),
    adminApi: maskedCredentialsSchema,
    shopperApi: maskedCredentialsSchema.nullable(),
    cartProductId: z.string().nullable(),
    storeUrl: z.string().nullable(),
    exchangeOrderShippingMethodId: z.string().nullable(),
    exchangeOrderPaymentMethodId: z.string().nullable(),
    exchangeOrderCartridgeEnabled: z.boolean(),
    exchangeOrderShippingPriceSource,
    storefrontLocale: z.string().nullable(),
  }),
};

export type CommerceCloudSetup = z.infer<typeof getCommerceCloudSetup.output>;
